import { Field } from '../declarations/widget-ums';

export function getValue<T = string>(field: Field<T>): T {
  return field.value;
}

export function getTextValue(field = { value: { text: '' } }): string {
  return field.value.text;
}
